import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CarPetedIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CarPetedIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.5039 7.77473C21.8275 7.77473 22.0898 7.51239 22.0898 7.18879C22.0898 6.86519 21.8275 6.60285 21.5039 6.60285H20.1367V4.92969H21.5039C21.8275 4.92969 22.0898 4.66735 22.0898 4.34375C22.0898 4.02015 21.8275 3.75781 21.5039 3.75781H6.70316C6.44234 2.74809 5.52367 2 4.43359 2C3.14125 2 2.08984 3.0514 2.08984 4.34375V19.6562C2.08984 20.9486 3.14124 22 4.43359 22H21.5039C21.8275 22 22.0898 21.7376 22.0898 21.414C22.0898 21.0904 21.8275 20.8281 21.5039 20.8281H20.1367V19.1549H21.5039C21.8275 19.1549 22.0898 18.8926 22.0898 18.569C22.0898 18.2454 21.8275 17.983 21.5039 17.983H20.1367V16.3099H21.5039C21.8275 16.3099 22.0898 16.0476 22.0898 15.724C22.0898 15.4004 21.8275 15.138 21.5039 15.138H20.1367V13.4648H21.5039C21.8275 13.4648 22.0898 13.2025 22.0898 12.8789C22.0898 12.5553 21.8275 12.2929 21.5039 12.2929H20.1367V10.6198H21.5039C21.8275 10.6198 22.0898 10.3574 22.0898 10.0338C22.0898 9.71023 21.8275 9.44789 21.5039 9.44789H20.1367V7.77473H21.5039ZM18.9648 20.8281H6.46203C6.66215 20.4831 6.77734 20.083 6.77734 19.6562H17.207C17.5306 19.6562 17.793 19.3939 17.793 19.0703V6.68751C17.793 6.36392 17.5306 6.10157 17.207 6.10157H6.77734V4.9297H18.9648L18.9648 20.8281ZM6.77734 11.8059L9.55194 9.84727L13.8471 12.8789L9.55194 15.9105L6.77734 13.9519V11.8059ZM9.21401 17.1064C9.41659 17.2494 9.68721 17.2494 9.88979 17.1064L15.2011 13.3576C15.5281 13.1402 15.528 12.6176 15.2011 12.4002L9.88979 8.65138C9.68717 8.50841 9.41655 8.50837 9.21401 8.65138L6.77734 10.3715V7.27345H16.6211V18.4844H6.77734V15.3863L9.21401 17.1064ZM3.26172 4.34376C3.26172 3.69759 3.78742 3.17189 4.43359 3.17189C5.07976 3.17189 5.60546 3.69759 5.60546 4.34376V17.627C4.89687 17.2093 3.97027 17.2093 3.26171 17.627L3.26172 4.34376ZM3.26172 19.6562C3.26172 19.0101 3.78742 18.4844 4.43359 18.4844C5.07976 18.4844 5.60546 19.0101 5.60546 19.6562C5.60546 20.3024 5.07976 20.8281 4.43359 20.8281C3.78742 20.8281 3.26172 20.3024 3.26172 19.6562Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CarPetedIcon;
